import { render, staticRenderFns } from "./TtfbMiniChart.vue?vue&type=template&id=3cc35a11&scoped=true&"
import script from "./TtfbMiniChart.vue?vue&type=script&lang=js&"
export * from "./TtfbMiniChart.vue?vue&type=script&lang=js&"
import style0 from "./TtfbMiniChart.vue?vue&type=style&index=0&id=3cc35a11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc35a11",
  null
  
)

export default component.exports